interface BatchAnalysisProgressProps {
  visible: boolean;
  current: number;
  total: number;
  label: string;
}

export default function BatchAnalysisProgress({
  visible,
  current,
  total,
  label,
}: BatchAnalysisProgressProps) {
  if (!visible) return null;

  const pct = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="mb-8 bg-white rounded-[20px] p-6 border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-gray-900">
          {label}
        </span>
        <span className="text-xs font-mono text-gray-400">
          {current}/{total}
        </span>
      </div>
      <div className="w-full rounded-full h-1.5 bg-gray-100">
        <div
          className="rounded-full h-1.5 transition-all duration-300"
          style={{
            width: `${pct}%`,
            background: "linear-gradient(90deg, #5050EA, #85A2FF)",
          }}
        />
      </div>
    </div>
  );
}
